// Costruzione righe regioni/province per la Dashboard Export da /dashboard/province-geo.
const ACC = ['tim', 'non_tim', 'pending', 'esportabili', 'esportati', 'controllati', 'tot'];

export function buildAreaRows(provinceMap, opts = {}) {
  const showToWork = opts.showToWork !== false;
  const province = Object.entries(provinceMap || {}).map(([nome, d]) => {
    const tim = d.tim || 0;
    const non_tim = d.non_tim_totale || 0;
    const pending = d.pending || 0;
    return {
      nome,
      regione: d.regione || '—',
      tim,
      non_tim,
      pending,
      esportabili: d.esportabili || 0,
      esportati: d.esportati || 0,
      controllati: tim + non_tim,
      tot: tim + non_tim + pending,
    };
  });
  const regMap = {};
  province.forEach((r) => {
    const reg = r.regione || '—';
    if (!regMap[reg]) { regMap[reg] = { nome: reg }; ACC.forEach((k) => { regMap[reg][k] = 0; }); }
    ACC.forEach((k) => { regMap[reg][k] += r[k]; });
  });
  const regioni = Object.values(regMap);
  const filt = (rows) => (showToWork ? rows : rows.filter((r) => r.esportabili > 0));
  return { regioni: filt(regioni), province: filt(province) };
}
